export function executePDFDownload(blob, pdfName) {
  const pdfLink = document.createElement('a');
  pdfLink.setAttribute('href', URL.createObjectURL(blob));
  if (pdfName) {
    pdfLink.setAttribute('download', `${pdfName}.pdf`);
  }
  document.body.appendChild(pdfLink);
  pdfLink.click();
}